import {
  ChkIconArrowRight,
  ChkIconChipTan,
  ChkIconPhotoTan,
  ChkIconPushTan,
  ChkIconSmsTan,
} from '@ui/checkout-components';

import { CANCELLATION_REASONS } from '../../global.constants';
import type { CancellationReason } from '../../global.types';
import { TEST_IDS } from '../../models/globals/testIds.constants';
import { TRANSLATION_KEYS } from '../../utils/TranslationKeys';

export const AUTHENTICATION_METHODS_VIEW_NAME = 'Authentication Methods view';
export const AUTHENTICATION_METHODS_VIEW_SELECT_DISABLED_REASON_ID =
  'authentication-methods-view-select-disabled-reason';

export const AUTHENTICATION_METHODS_VIEW_CANCELLATION_REASONS = [
  CANCELLATION_REASONS.myAuthorisationMethodIsNotDisplayed,
  CANCELLATION_REASONS.doNotHaveMyDeviceAtHand,
  CANCELLATION_REASONS.other,
] satisfies CancellationReason[];

export const AUTHENTICATION_METHODS_PROPS = {
  PUSH_OTP: {
    title: TRANSLATION_KEYS.PUSH_TAN_HEADER,
    subtitle: TRANSLATION_KEYS.PUSH_TAN_SUBHEADER,
    icon: (
      <ChkIconPushTan
        data-testid={TEST_IDS.AUTHENTICATION_VIEW.PUSH_OTP.icon}
      />
    ),
  },
  CHIP_OTP: {
    title: TRANSLATION_KEYS.CHIP_TAN_HEADER,
    subtitle: TRANSLATION_KEYS.CHIP_TAN_SUBHEADER,
    icon: (
      <ChkIconChipTan
        data-testid={TEST_IDS.AUTHENTICATION_VIEW.CHIP_OTP.icon}
      />
    ),
  },
  SMS_OTP: {
    title: TRANSLATION_KEYS.M_TAN_HEADER,
    subtitle: TRANSLATION_KEYS.M_TAN_SUBHEADER,
    icon: (
      <ChkIconSmsTan data-testid={TEST_IDS.AUTHENTICATION_VIEW.SMS_OTP.icon} />
    ),
  },
  PHOTO_OTP: {
    title: TRANSLATION_KEYS.PHOTO_TAN_HEADER,
    subtitle: TRANSLATION_KEYS.PHOTO_TAN_SUBHEADER,
    icon: (
      <ChkIconPhotoTan
        data-testid={TEST_IDS.AUTHENTICATION_VIEW.PHOTO_OTP.icon}
      />
    ),
  },
  REDIRECT: {
    title: TRANSLATION_KEYS.REDIRECT_OTP_HEADER,
    subtitle: TRANSLATION_KEYS.REDIRECT_OTP_SUBHEADER,
    icon: (
      <ChkIconArrowRight
        data-testid={TEST_IDS.AUTHENTICATION_VIEW.REDIRECT.icon}
      />
    ),
  },
} as const;
